export default {
  login_register: 'Login/Registrazione',
  booking_confirmation_title: 'Conferma prenotazione',
  booking_confirmation_body: 'Grazie per aver prenotato. Visualizza i dettagli di conferma qui sotto.',
  insurance_requirements_modal_disclaimer: `Effettuando questa prenotazione, confermo che: negli ultimi 5 anni non ho avuto condanne o offese automobilistiche. Non ho rifiutato una proposta, una polizza annullata o un rinnovo rifiutato o mi è stato richiesto di pagare un premio maggiorato o sono state imposte condizioni speciali da qualsiasi assicuratore automobilistico. Non sono stato squalificato dalla guida. Non ho un procedimento giudiziario o un'indagine di polizia in corso. Non ho alcuna condanna per reati relativi a furto, frode o disonestà negli ultimi 5 anni. Non ho sofferto di visione o udito difettosi (non corretti da occhiali o apparecchi acustici), disturbi cardiaci, diabete, attacchi o qualsiasi infermità fisica o mentale di qualsiasi tipo. Non ho avuto incidenti negli ultimi 5 anni. Fare clic {0} se non si soddisfano questi requisiti`,
  insurance_requirements_here: 'qui',
  insurance_requirements: `Ho letto e accetto di soddisfare i {0}`,
  ir: 'Requisiti Assicurativi',
  location: 'Luogo',
  pickup_location: 'Luogo di ritiro',
  dropoff_location: 'Luogo di deposito',
  vehicle: 'Veicolo',
  pickup_and_dropoff: 'Ritiro e deposito (ora locale)',
  distance_allowance: 'Distanza permessa',
  view_voucher: 'Visualizza voucher',
  view_more_bookings: 'Vedi più prenotazioni',
  identity_verification_body: 'Dovrai verificare la tua identità prima di ritirare il veicolo',
  identity_verification_title: 'Verifica identità',
  search_again: 'Cerca di nuovo',
  not_available: 'Drive &amp; Go è attualmente disponibile solo per chi è in possesso di una patente di guida fornita da: {profiles}, ma stiamo costantemente aggiungendo altre nazioni.',
  check_if_included: 'Controlla se è inclusa la tua nazione.',
  included_in_booking: 'Incluso in questa prenotazione',
  cdw_with_excess: 'Con eccesso di assicurazione (CDW)',
  theft_protection: 'Assicurazione contro il furto con eccesso',
  risk_reduction: 'Riduzione del rischio',
  free_extras: 'Hai diritto a due ulteriori extra gratuiti <br /> con questa prenotazione.',
  total_cost: 'Costo totale del noleggio',
  continue: 'Continua',
  luggage_large_short_label: 'G',
  luggage_medium_short_label: 'M',
  luggage_small_short_label: 'P',
  luggage_large_long_label: 'grande',
  luggage_medium_long_label: 'media',
  luggage_small_long_label: 'piccola',
  fuel_unspecified_label: 'non specificato',
  transmission_manual_label: 'Manuale',
  transmission_automatic_label: 'Automatico',
  make_a_booking: 'Effettua una prenotazione',
  pickup_date: 'Data del ritiro',
  dropoff_date: 'Data del deposito',
  driver_age: 'Età conducente tra i 30 e i 65 anni',
  enter_driver_age: 'Inserire l\'età del conducente',
  promo_code: 'Codice promozionale',
  search: 'Cerca',
  dropoff_date_cannot_be_before_pickup_date: 'La data di deposito non può essere antecedente alla data di ritiro',
  pickup_date_cannot_be_in_the_past: 'La data di ritiro non può essere già passata',
  pickup_time_cannot_be_in_the_past: 'L\'orario di ritiro non può essere già passato',
  dropoff_time_must_be_later_than_the_pickup_time_if_on_the_same_day: 'L\'orario di deposito deve essere successivo all\'orario di ritiro se effettuati nello stesso giorno',
  vehicle_filters: 'Filtri veicolo',
  reset: 'Ripristina',
  transmission: 'Trasmissione',
  all: 'Tutte',
  manual: 'Manuale',
  auto: 'Automatica',
  passengers: 'Passeggeri',
  vehicle_type: 'Tipo di veicolo',
  filter: 'Filtro',
  vehicle_search: 'Ricerca veicolo',
  edit: 'Modifica',
  no_results: 'Nessun risultato corrisponde ai criteri del filtro.',
  small_cars: 'Auto piccole',
  medium_cars: 'Auto medie',
  large_cars: 'Auto grandi',
  estate_cars: 'Station wagon',
  suvs: 'SUV',
  mpvs: 'Monovolume',
  vans: 'Furgone',
  camper_vans: 'Camper',
  premium: 'Premium',
  unspecified: 'non specificato',
  large: 'grande',
  medium: 'media',
  small: 'piccola',
  automatic: 'automatico',
  you_have_been_refunded: 'Sei stato rimborsato.',
  please_customer_service: 'Per effettuare una prenotazione contatta il Servizio Clienti.',
  contact_customer_service: 'Contatta il Servizio Clienti',
  booking_failed: 'Non è stato possibile processare la tua prenotazione.',
  summary: 'Sommario',
  reforestation_and_protection: 'Sostiene il rimboschimento e la protezione delle foresta pluviali in tutta la Costa Rica',
  cost_of_rental: 'Costo del noleggio',
  to_pay_now: 'Da pagare ora',
  pay_on_arrival: 'Da pagare all\'arrivo',
  greenheart_donation: 'Green heart donation',
  tc_agreement: 'Ho letto e compreso i {0}.',
  tc: 'Termini e Condizioni',
  receive_offers: 'Vorrei ricevere offerte speciali tramite email.',
  donate: 'Sì, vorrei donare {amount}',
  pay_now: 'Paga {amount} ora',
  driver_details: 'Dettagli del conducente',
  complete_driver_details: 'Completa i dettagli del conducente.',
  are_you_the_driver: 'Sei tu il conducente?',
  have_an_account: 'Hai già un account?',
  login: 'Accedi',
  or: 'o',
  first_name: 'Nome del conducente',
  last_name: 'Cognome del conducente',
  email: 'Indirizzo email',
  phone_number: 'Numero di cellulare',
  unable_to_save_driver_information: 'Impossibile salvare le informazioni del conducente. Riprova.',
  pay_online_now: 'Paga ora online',
  day: 'Giorno',
  choose_location: 'Scegli un luogo',
  location_not_found: 'Spiacenti, impossibile trovare il luogo richiesto.',
  add: 'Aggiungi',
  remove: 'Rimuovi',
  free_extra: 'Extra gratuito',
  free: 'GRATUITO!',
  fast_track_notice: 'Per questo servizio si applicano restrizioni riguardanti l\'origine del documento. Disponibile solo per le persone con un documento rilasciato da',
  complete_booking: 'Completa la prenotazione',
  choose_card: 'Scegli una carta o aggiungine una nuova.',
  add_billing_details: 'Aggiungi i dettagli di pagamento.',
  card_number: 'Numero carta',
  card_holder_name: 'Nome del proprietario della carta',
  card_exp: 'MM / AA',
  card_cvc: 'CVC',
  save_card: 'Memorizzare la carta?',
  amount_charged: 'L\'addebito verrà effettuato sulla tua carta',
  payment_confirmation: 'Conferma la prenotazione e paga',
  payment_methods: 'metodi di pagamento disponibili',
  use_saved_card: 'x usa carta memorizzata',
  use_different_card: '+ usa una carta diversa',
  book_now: 'Prenota ora',
  minimum_age: 'Solo oltre {age} anni',
  excess_liability: 'Franchigia danni',
  security_deposit: 'Deposito cauzionale',
  fuel_policy: 'Politica del carburante',
  like_for_like: 'Like for Like',
  full_to_full: 'Full to Full',
  miles_per_rental: '{mileage} miglia gratuiti per noleggio',
  km_per_rental: '{mileage} km gratuiti per noleggio',
  unlimited: 'Illimitati',
  unlimited_mileage: 'Miglia illimitati',
  unlimited_mileage_km: 'Km illimitati',
  non_amendable: 'Non modificabile',
  non_refundable: 'Non rimborsabile',
  free_cancellation_until: 'Cancellazione gratuita fino al',
  cancellation_in_line_with: 'Cancellazione in linea con',
  tcs: 'T&amp;C',
  free_extras_on_collection: 'Due extra gratuiti al ritiro',
  glass_and_tyres_covered: 'Copertura vetri e gomme',
  number_of_passengers: 'Numero di passeggeri',
  number_of_bags: 'Numero di bagagli',
  fuel_type: 'Tipo di carburante',
  co2: 'CO2',
  aircon: 'Aria condizionata',
  refrigeration: 'Refrigerato',
  book_type: 'Prenota {type}',
  processing: 'Elaborazione in corso',
  actual_price: 'Prezzo attuale',
  tooltip: 'Il prezzo in ${currencyCode} è una stima basata sul tasso di cambio, il prezzo in ${currency} è vincolante.',
  deposit: 'Deposito',
  pay_online: 'Paga ora online',
  pay_online_without_extras: 'Prezzo del noleggio',
  extras_on_arrival: 'Extra all\'arrivo',
  insurance_on_arrival: 'Riduzione del rischio - Paga all\'arrivo',
  insurance_online: 'Riduzione del rischio - Paga ora',
  extras_online: 'Paga ora gli extra',
  green_heart_donation: 'Green Heart donation',
  aircon_lower: 'aria condizionata',
  why_use_drive_and_go: 'Perché usare Drive & Go?',
  straight_to_car: 'Subito in auto',
  no_queues: 'Nessuna fila',
  self_checkout: 'Checkout indipendente',
  cant_lose_key: 'Impossibile perdere le chiavi',
  online_id_check: 'Controllo documento di identità online',
  phone_as_key: 'Telefono come chiave',
  premiumplus_benefits_includes: 'Inclusi anche vantaggi Premium Plus+',
  book_drive_go: 'Prenota Drive & Go',
  duration: 'Durata',
  to_pay_on_arrival: 'Da pagare all\'arrivo',
  return_date: 'Data di ritorno',
  postcode: 'Codice postale',
  country: 'Nazione',
  my_profile: 'Il mio profilo',
  additional_options: 'Opzioni aggiuntive',
  booking_details: 'Dettagli prenotazione',
  price_for_x_days: 'Prezzo per {qty_of_days} giorno | Prezzo per {qty_of_days} giorni',
  cancelled: 'Annullato',
  upcoming: 'In arrivo',
  active: 'Attivo',
  drive_and_go: {
    drive_and_go: 'Drive And Go',
    available_countries: 'Drive &amp; Go è attualmente disponibile solo per chi è in possesso di una patente di guida fornita dalle seguenti nazioni:',
    drive_and_go_today: 'Prenotazione odierna con Drive & Go!',
    drive_and_go_shortened: 'Drive & Go',
    why_use_drive_and_go: 'Perché usare Drive & Go?',
    straight_to_car: 'Subito in auto',
    no_queues: 'Nessuna fila',
    self_checkout: 'Checkout indipendente',
    cannot_lose_the_key: 'Impossibile perdere le chiavi',
    online_id_check: 'Controllo documento di identità online',
    phone_as_a_key: 'Telefono come chiave',
    premium_plus_benefits_also_included: 'Inclusi anche vantaggi Premium Plus+',
    book_drive_and_go: 'Prenota Drive & Go'
  },
  my_bookings: "Le mie prenotazioni",
  no_bookings: "Nessuna prenotazione",
  no_bookings_to_display: 'Nessuna prenotazione da visualizzare.',
  search_great_car_rental_deals: "Search great car rental deals for your next trip.",
  odometer_at_collection: 'Contachilometri al ritiro',
  fuel_at_collection: 'Carburante al ritiro',
  start_check_in: 'Inizia il check-in',
  start_collection: 'Inizia il ritiro',
  recent_bookings: 'Prenotazioni recenti',
  damage: {
    updated_damage_report_submitted: 'È stato inviato un aggiornamento sul rapporto dei danni. Un membro del nostro Servizio Clienti si metterà in contatto se necessario.',
    add_additional_damage: 'Aggiungi danni aggiuntivi',
    you_may_report_additional_damage_up_to: 'Puoi segnalare ulteriori danni fino a 24 ore dopo la restituzione del veicolo',
    specify_damage: 'Specifica danno',
    please_choose_the_area_and_type_of_damage: 'Scegli la zona e il tipo di danno',
    type_of_damage: 'Tipo di danno',
    is_this_more_than_5_cm: 'È più grande di 5 cm?',
    please_take_or_select_a_photo: 'Scatta o seleziona una foto',
    please_take_a_photo_ensuring_the_damage_is_clearly_visible: 'Scatta una foto assicurandoti che il danno sia ben visibile',
    if_you_require_you_may_add_another_photo_select_the_icon_to_add_another_photo: ' Se necessario puoi aggiungere un\'altra foto selezionando l\'icona per aggiungere un\'altra foto',
    save_image: 'Salva l\'immagine',
    save_images: 'Salva le immagini',
    damage_saved_successfully: 'Danno salvato con successo',
    add_photo: 'Aggiungi foto'
  },
  checkout: {
    start_collection: 'Inizia il ritiro',
    collect_vehicle: 'Ritira il veicolo',
    we_will_let_you_know_the_details: 'Ti faremo sapere il luogo e i dettagli per permetterti di localizzare il veicolo noleggiato.',
    inspect: 'Ispeziona',
    we_will_ask_for_four_photos_from_each_corner: 'Ti verrà richiesto di effettuare quattro foto da ciascun angolo del veicolo insieme ad eventuali danni non ancora segnalati.',
    fuel_and_milage: 'Carburante e chilometraggio',
    you_confirm_the_readings_at_the_start_of_your_hire: 'Conferma la lettura del contachilometri e del carburante all\'inizio del tuo noleggio.',
    sign: 'Firma',
    sign_the_rental_agreement: 'Firma il contratto di noleggio',
    away_you_go: 'Pronto a partire',
    you_are_free_to_take_to_the_road: 'Puoi andare in strada!',
    collect_your_vehicle: 'Ritira il tuo veicolo',
    get_directions: 'Ottieni indicazioni',
    hide_directions: 'Nascondi indicazioni',
    local_time: 'ora locale',
    tel: 'Tel',
    getting_to_the_location: 'Come arrivare alla posizione',
    get_vehicle_details: 'Ottieni informazioni veicolo',
    view_map: 'Visualizza mappa',
    unlock_vehicle_and_continue: 'Sblocca il veicolo e continua',
    unable_to_connect_to_vehicle: 'Impossibile connettersi al veicolo',
    we_were_unable_to_connect_to_the_vehicle_please_check: 'È stato impossibile effettuare la connessione al veicolo: controlla di trovarti vicino al veicolo giusto e riprova.',
    we_were_unable_to_find_the_vehicle_booking_please_try_again_later: 'È stato impossibile trovare la prenotazione del veicolo. Riprova più tardi.',
    odometer_and_fuel: 'Contachilometri e carburante',
    odometer: 'Contachilometri',
    please_confirm_the_odometer_and_fuel_readings: 'Se possibile, confermare le letture del contachilometri e del carburante',
    the_odometer_field_is_required: 'Il campo contachilometri deve essere compilato',
    and_must_be_greater_than_the_checkout_odometer: 'e il numero inserito deve essere superiore a quello del chilometraggio del check-out',
    confirm: 'Conferma',
    please_take_a_photo_from_each_corner_of_the_vehicle: 'Scatta una foto da ogni angolo del veicolo',
    pre_existing_damage: 'Danno preesistente',
    no_pre_existing_damage: 'Nessun danno preesistente.',
    new_damage: 'Nuovo danno',
    add_additional_damage: 'aggiungi danno aggiuntivo',
    no_new_damage_to_report: 'Nessun nuovo danno da segnalare',
    checkout_complete: 'Checkout completo',
    start_rental: 'Avvia noleggio',
    congratulations_name_it_is_time_to_take_to_the_road: 'Complimenti {customer_name} è ora di partire!',
    we_are_unable_to_complete_your_vehicle_checkout: 'È stato impossibile completare il checkout del veicolo.',
    please_do_the_following: 'Segui le seguenti istruzioni',
    remove_all_belonging_and_lock_the_vehicle: 'Rimuovi tutti gli effetti personali e blocca il veicolo.',
    lock_vehicle: 'Blocca il veicolo',
    once_you_have_contacted_customer_services: 'Una volta aver contattato il servizio clienti',
    vehicle_location: 'Posizione del veicolo',
    collect_your: 'Ritira il tuo',
    from: 'Da',
    key_in_glove_box: 'la tua chiave si trova nel vano portaoggetti',

    keyholder: {
      not_detected: 'Chiave non rilevata nel portachiavi',
      not_detected_please_try_again: 'Inserire la chiave nel portachiavi, quindi riprovare.',

      not_installed: 'Portachiavi non installato',
      not_installed_please_contact_customer_service: 'Il portachiavi non è installato, si prega di contattare il servizio clienti.',
    },
    keyring: {
      look_up_failed: 'Ricerca portachiavi non riuscita',
      look_up_failed_please_contact_customer_service: 'Portachiavi cercare faled, si prega di contattare il servizio clienti.',
    },
    key: {
      invalid: 'La chiave non è valida',
      invalid_please_contact_customer_service: 'La tua chiave non è valida, contatta il servizio clienti.',

      expired: 'La chiave è scaduta',
      expired__please_contact_customer_service: 'La chiave è scaduta, contatta il servizio clienti.',
    }
  },
  checkin: {
    start_check_in: 'Inizia il check-in',
    vehicle_location: 'Posizione del veicolo',
    tell_us_where_you_have_parked: 'Dicci dove hai parcheggiato il tuo veicolo.',
    fuel_and_milage: 'Carburante e chilometraggio',
    you_confirm_the_readings_at_the_end_of_your_hire: 'Alla fine del noleggio conferma la lettura del contachilometri e del carburante.',
    inspect: 'Ispeziona',
    we_will_as_for_four_photos_from_each_corner_of_the_vehicle_along_with_any_new_damage: 'Ti chiederemo di scattare quattro foto riprendendo il veicolo dai quattro angoli insieme a eventuali nuovi danni provocati durante il noleggio.',
    lock: 'Blocca',
    check_you_have_left_no_belonging_then_lock_the_vehicle: 'Controlla di non aver lasciato effetti personali e poi blocca il veicolo.',
    please_tell_us_where_you_have_parked_the_vehicle: 'Dicci dove hai parcheggiato il tuo veicolo',
    once_the_vehicle_is_locked_you_will_be_unable_to_unlock_it_again: 'Una volta bloccato il veicolo potrai sbloccarlo nuovamente.',
    name_please_check_you_have_left_no_belongings_then_lock_the_vehicle: '{first_name}, controlla di non aver lasciato alcun oggetto, blocca il veicolo e, se necessario, restituisci la chiave fisica al portachiavi.',
    lock_vehicle: 'Blocca il veicolo',
    complete_check_in: 'Completa il check-in',
    inspection: 'Ispezione',
    complete_vehicle_check_in: 'Completa il check-in del veicolo',
    we_are_unable_to_complete_your_vehicle_check_in: 'È stato impossibile completare il check-in del tuo veicolo.',
    please_contact_customer_services: 'Contatta il Servizio Clienti',
    once_you_have_contacted_customer_services: 'Una volta aver contattato il servizio clienti',
    please_amend_odometer_to_be_greater_than: 'Modifica il contachilometri in modo che sia maggiore di {odometer_value}',
  },
  rental_agreement: {
    rental_agreement: 'Contratto di noleggio',
    agreement_between: 'Contratto tra',
    and: 'e',
    sign_rental_agreement: 'Firma il contratto di noleggio',
    i_have_read_and_understood_the_terms_and_conditions: 'Ho letto e compreso i Termini e Condizioni'
  },
  full_insurance_no_deposit: 'Assicurazione completa e nessun deposito richiesto',
  excess: '{amount} in eccesso',
  deposit: '{amount} deposito',
  included_daily_distance: '{distance} {unit} al giorno',
  miles: 'miglia',
  kilometers: 'chilometri',
  collection_details_title: 'Dettagli della raccolta',
  collection_details_not_found: 'Nessun dettaglio della raccolta definito per questa località',
  free_cancellation: 'Cancellazione gratuita',
  no_deposit: 'senza Deposito',
  benefit_from: 'Benefici da',
  for_only_per_day: 'Per soli {price} al giorno',
  upgrade_mee: 'UpgradeMee'
}


// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/it/bookings.js